import { map, OperatorFunction } from 'rxjs';
import { IMessage } from '../message';
import { MessageEvent, MessageEventType } from '../message-event';
/**
 * @param type The message type
 *
 * @returns
 * An operator that takes a message and maps it to a
 * `MessageEvent` with the given `type`.
 */
export function mapToMessageEvent<T extends IMessage>(
  type: MessageEventType,
): OperatorFunction<T, MessageEvent<T>> {
  return map((message) => ({
    type,
    message: { ...message },
  }));
}
